import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from 'app/private/containers/dashboard';
import useRequireAuth from 'hooks/use-require-auth';
import Users from 'app/private/containers/users';
import Admins from 'app/private/containers/admins';
import { ERoutesPrivate, ERoutesType, routes } from 'types/routes';
import TransactionsHistory from './containers/transactions-history';
import Withdraws from './containers/withdraws';
import PendingTasks from './containers/pending-tasks';
import Screenings from './containers/screenings/screenings';
import TwoFA from './containers/two-fa';
import useEnabled2FA from '../../hooks/use-is-enabled-2fa';
import useCurrentSessionData from 'hooks/use-current-session-data';
import NoAccess from 'components/no-access';
import EkycIndividual from './containers/ekyc';
import AdminActivityLog from './containers/admin-activity-log';
import UserActivityLog from './containers/user-activity-log';

const privateRoutes = routes[ERoutesType.Private];

const Private = () => {
    useRequireAuth();
    const isEnabled2FA = useEnabled2FA();
    const { permissions } = useCurrentSessionData();

    return (
        <Switch>
            <Route path={privateRoutes[ERoutesPrivate.Dashboard]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                <Dashboard />
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.Admins]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                {permissions?.adminsView ? <Admins /> : <NoAccess />}
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.Users]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                {permissions?.userView ? <Users /> : <NoAccess />}
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.Transactions]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                {permissions?.transactionView ? (
                    <TransactionsHistory />
                ) : (
                    <NoAccess />
                )}
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.Screenings]}>
                {!isEnabled2FA && (
                    <Redirect
                        to={privateRoutes[ERoutesPrivate.Screenings][0]}
                    />
                )}
                <Screenings />
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.Withdraws]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                {permissions?.withdrawalView ? <Withdraws /> : <NoAccess />}
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.PendingTasks]}>
                {!isEnabled2FA && (
                    <Redirect to={privateRoutes[ERoutesPrivate.TwoFA][0]} />
                )}
                {permissions?.pendingTaskView ? <PendingTasks /> : <NoAccess />}
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.TwoFA]}>
                <TwoFA />
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.EKYC]}>
                <EkycIndividual />
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.AdminActivityLog]}>
                <AdminActivityLog />
            </Route>
            <Route path={privateRoutes[ERoutesPrivate.UserActivityLog]}>
                <UserActivityLog />
            </Route>
            <Redirect to={privateRoutes[ERoutesPrivate.Dashboard][0]} />
        </Switch>
    );
};

export default Private;
